import * as React from 'react'
// components
import { Header } from 'components/Modals/PlanItems/styles'
import { DrawerModal } from 'components/UI'
// context
import { ObjectSecurityContext } from 'containers/Security/components/ObjectSecurity/layers/API'
// view components
import ObjectSecurityCreateForm from 'components/Modals/ObjectSecurityModal/Form'
// hooks
import { useModalData } from 'hooks/index'
// constants
import { Modals } from 'constants/modals'
// themes
import { CloseIcon } from 'components/UI/Icons'

const PAPER_PROPS = {
  style: {
    height: '100%',
    overflow: 'hidden',
    top: 0
  }
}

const ObjectSecurityModal: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen, isEdit, objectSecurity }
  } = useModalData({ modalType: Modals.OBJECT_SECURITY_MODAL })

  const { createObjectSecurity, updateObjectSecurity } = React.useContext(ObjectSecurityContext)

  const handleFormSubmit = async (data) =>
    isEdit
      ? await updateObjectSecurity(objectSecurity.id, data, hideModal)
      : await createObjectSecurity(data, hideModal)

  const initialValues = isEdit
    ? {
        active: objectSecurity.active,
        description: objectSecurity.description,
        name: objectSecurity.name,
        object: { label: objectSecurity.objectEntity.name, value: objectSecurity.objectEntity.apiName },
        profiles: objectSecurity.securityProfiles.map((profile) => ({ label: profile.name, value: profile.id }))
      }
    : { active: true }

  return (
    <DrawerModal width={'600px'} isOpen={isOpen} hideModal={hideModal} PaperProps={PAPER_PROPS}>
      <Header>
        <span>{`${isEdit ? 'Edit' : 'Create'} Object Security`}</span>
        <CloseIcon onClick={hideModal} />
      </Header>
      <ObjectSecurityCreateForm
        hideModal={hideModal}
        initialValues={initialValues}
        isEdit={isEdit}
        objectSecurity={objectSecurity}
        onSubmit={handleFormSubmit}
      />
    </DrawerModal>
  )
}

export default ObjectSecurityModal
